module.exports = "/_next/static/images/runner-card-6b07a9ee6b7ddc2bd27e8338949d0b2b.png";